export const STATE = '/state/' as const
export const STATE_ALL = `${STATE}all` as const
